import { Place } from '@mui/icons-material';
import { Button, Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/styles';
import moment from 'moment';
import React, { useState } from 'react';
import ShowMoreText from 'react-show-more-text';
import { useSetEventReminderMutation } from '../../api/apiSlice';
import convertDMS from '../../utils/convertDMS';
import EventMap from './EventMap';

export default function EventCard({
    id,
    name,
    venue,
    desc,
    date,
    time,
    reminder,
}) {
    const [reminderStatus, setReminderStatus] = useState(reminder?.set);

    const theme = useTheme();
    const [setEventReminder] = useSetEventReminderMutation();

    const openLocation = () =>
        window.open(
            `https://www.google.com/maps/place/${convertDMS(
                venue?.latitude,
                venue?.longitude
            )}/@${venue?.latitude},${venue?.longitude},18z`
        );

    return (
        <Grid item xs={12}>
            <Card
                variant="outlined"
                style={{
                    borderRadius: theme.shape.borderRadius,
                    borderWidth: 2,
                }}
            >
                <CardContent>
                    <Typography style={{ fontWeight: 'bold' }} variant="h6">
                        {name}
                    </Typography>
                    <Typography>{venue?.name}</Typography>
                    <ShowMoreText lines={2} more="more" less="less">
                        {desc}
                    </ShowMoreText>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Typography>
                            {moment(date).format('MMM Do YYYY')}
                        </Typography>
                        <Typography>{time}</Typography>
                    </div>
                    <EventMap
                        location={{
                            lat: venue?.latitude,
                            lng: venue?.longitude,
                        }}
                    />
                    <div className="d-flex justify-content-between">
                        <Button
                            size="medium"
                            variant="outlined"
                            className="text-capitalize"
                            startIcon={<Place />}
                            onClick={openLocation}
                        >
                            Location
                        </Button>
                        <Button
                            variant={reminderStatus ? 'outlined' : 'contained'}
                            size="medium"
                            className="text-capitalize"
                            onClick={() => {
                                setEventReminder(id);
                                setReminderStatus(!reminderStatus);
                            }}
                        >
                            {reminderStatus ? 'Drop Reminder' : 'Set Reminder'}
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </Grid>
    );
}
